import * as Yup from "yup";

export const askQuestionSchema = Yup.object({
  question: Yup.string().required().min(10).max(120),
});

export const productReviewSchema = Yup.object({
  rating: Yup.number().required("Review "),
  description: Yup.string()
    .required("Review can not be empty")
    .min(10)
    .max(500),
});
